<template>
  <v-container fluid py-0>
    <v-row justify="center">
      <v-col cols="12" class="py-0">
        <v-row align="center">
          <v-col cols="6">
            <v-text-field
              label="Supplier"
              v-model="supplier"
              :outlined="outlinedInputs"
              hide-details
              clearable
              v-on:keyup.enter="onSearch"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Service"
              v-model="service"
              :outlined="outlinedInputs"
              hide-details
              clearable
              v-on:keyup.enter="onSearch"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0 mb-0">
            <v-row justify="center" align="baseline">
              <v-radio-group
                v-if="multiSupplierTypes"
                v-model="selectedSupplierTypes"
                row
                :disabled="$apollo.loading"
                class="ma-0 py-0"
                multiple
                dense
                hide-details
              >
                <v-radio
                  v-for="sType in supplierTypes"
                  :key="sType"
                  :value="sType"
                  @click="onSupplierTypeClick(sType)"
                  dense
                  hide-details
                >
                  <template v-slot:label>
                    <v-icon left>{{ supplierTypeIcon(sType) }}</v-icon>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-radio-group
                v-else
                v-model="selectedSupplierType"
                row
                :disabled="$apollo.loading"
                @change="onServiceTypeChange"
                class="ma-0 py-0"
                dense
                hide-details
              >
                <v-radio
                  v-for="sType in supplierTypes"
                  :key="sType"
                  :value="sType"
                  dense
                  hide-details
                >
                  <template v-slot:label>
                    <v-icon left>{{ supplierTypeIcon(sType) }}</v-icon>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-row>
            <v-row>
              <v-col classy="py-0">
                <v-expansion-panels v-model="searchPanel">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      More Options</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-row
                        ><v-col>
                          <destination-list-select
                            v-model="selectedDestinationId"
                            :outlined="outlinedInputs"
                            hide-details
                            dense
                            hide-not-in-use
                          ></destination-list-select> </v-col
                        ><v-col>
                          <service-type-multi-select
                            v-model="serviceTypes"
                            :supplier-types="serviceTypesNamesFilter"
                            :outlined="outlinedInputs"
                            hide-details
                            dense
                            hide-not-in-use
                          />
                        </v-col>
                        <v-col>
                          <stars-list-select
                            custom-label="Supplier Rating"
                            v-model="ratingFilter"
                            :outlined="outlinedInputs"
                            dense
                            multi
                          ></stars-list-select>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col>
                          <v-switch
                            v-model="multiSupplierTypes"
                            label="Multi"
                            class="my-0 py-0"
                            @change="onMultiSFRChange"
                            hide-details
                            dense
                          ></v-switch>
                        </v-col>
                        <v-col>
                          <v-switch
                            v-model="includeUnpriced"
                            label="Include Unpriced"
                            class="ml-2 my-0 py-0"
                            hide-details
                            dense
                            @change="onIncludeUnpricedChange"
                          ></v-switch>
                        </v-col>
                        <v-col>
                          <v-select
                            label="Sort by"
                            v-model="sortBy"
                            :items="sortByOptions"
                            :outlined="outlinedInputs"
                            @change="onSortChange"
                            dense
                            hide-details
                          />
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="12">
                          <v-range-slider
                            v-model="priceRangeSlider"
                            :min="0"
                            :max="10000"
                            :step="50"
                            thumb-label
                            label="Price Range"
                            hide-details
                            dense
                            class="mt-1"
                          ></v-range-slider>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col>
                          <v-text-field
                            label="Price From"
                            v-model.number="priceFromMin"
                            type="number"
                            min="0"
                            :outlined="outlinedInputs"
                            hide-details
                            dense
                            clearable
                            v-on:keyup.enter="onSearch"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            label="Price To"
                            v-model.number="priceFromMax"
                            type="number"
                            min="0"
                            :outlined="outlinedInputs"
                            hide-details
                            dense
                            clearable
                            v-on:keyup.enter="onSearch"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="py-0"
            ><v-row justify="center" align="center">
              <v-col class="py-0">
                <v-btn
                  color="primary"
                  @click="onSearch"
                  :loading="$apollo.loading"
                  block
                  dense
                  class="ma-0"
                  hide-details
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-container fluid>
          <v-divider></v-divider>
        </v-container>
        <v-row>
          <v-col cols="12">
            <v-expansion-panels :disabled="$apollo.loading" v-model="panel">
              <v-expansion-panel v-for="item in items" :key="item.id">
                <v-expansion-panel-header>
                  <v-row align="center">
                    <v-tooltip
                      bottom
                      z-index="300"
                      v-if="
                        item.imageURL ||
                        (item.description && item.description != '')
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-avatar size="24" v-on="on" class="mr-2">
                          <v-img
                            v-if="item.imageURL"
                            :src="item.imageURL"
                          ></v-img>
                        </v-avatar>
                      </template>
                      <v-container style="max-width: 500px">
                        <v-row>
                          <v-col
                            cols="12"
                            v-if="item.imageURL && item.imageURL != ''"
                          >
                            <v-img
                              contain
                              :src="item.imageURL"
                              max-height="200"
                            ></v-img>
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="max-lines"
                              v-html="item.description"
                            ></div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-tooltip>
                    <v-avatar v-else size="24" class="mr-2">
                      <v-icon> mdi-information</v-icon>
                    </v-avatar>
                    <strong
                      >{{ item.supplierName }} ({{ item.supplierCode }})
                      {{
                        item.headOfficeName != ""
                          ? `(${item.headOfficeName})`
                          : ""
                      }}
                    </strong>
                  </v-row>
                  <template v-if="item.priceFrom > 0">
                    From:&nbsp; {{ item.priceFrom | priceLabeler
                    }}{{ item.priceFromCurrencyCode }}
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0">
                  <v-list dense>
                    <draggable
                      v-model="item.availableServices"
                      :group="{ name: 'services', pull: 'clone', put: false }"
                      @start="drag = true"
                      @end="drag = false"
                      :clone="clone(item)"
                    >
                      <v-list-item
                        v-for="availableItem in item.availableServices"
                        :key="availableItem.id"
                        link
                        @click="onItemClick(availableItem, item)"
                      >
                        <v-list-item-avatar>
                          <v-tooltip bottom z-index="300">
                            <template v-slot:activator="{ on }">
                              <v-avatar v-on="on">
                                <v-img
                                  v-if="availableItem.service.imageURL"
                                  :src="availableItem.service.imageURL"
                                ></v-img>
                                <v-icon v-else color="green lighten-1">
                                  mdi-information</v-icon
                                >
                              </v-avatar>
                            </template>
                            <v-container style="max-width: 500px">
                              <v-row>
                                <v-col cols="12">
                                  <v-img
                                    contain
                                    :src="availableItem.service.imageURL"
                                  ></v-img>
                                </v-col>
                                <v-col cols="12">
                                  <div
                                    v-html="availableItem.service.description"
                                  ></div>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-tooltip>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-tooltip bottom z-index="300">
                              <template v-slot:activator="{ on }">
                                <span v-on="on"
                                  >{{ availableItem.serviceName }}
                                </span>
                              </template>
                              {{ availableItem.serviceName }}
                            </v-tooltip>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action
                          v-if="availableItem.priceFromCurrencyCode != ''"
                        >
                          <v-tooltip bottom z-index="300">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ availableItem.priceFrom | priceLabeler }}
                                {{ availableItem.priceFromCurrencyCode }}
                                ({{ availableItem.rateTypeCode }})
                              </span>
                            </template>
                            <item-prices-grid
                              :items="[...availableItem.prices]"
                            ></item-prices-grid>
                          </v-tooltip>
                        </v-list-item-action>

                        <v-list-item-action v-if="dragAndDrop">
                          <v-btn class="ma-0" text icon small>
                            <v-icon small>mdi-drag</v-icon>
                          </v-btn>
                        </v-list-item-action>
                        <v-list-item-action
                          v-else-if="availableItem.priceFromCurrencyCode != ''"
                        >
                          <v-tooltip bottom z-index="300">
                            <template v-slot:activator="{ on }">
                              <v-btn small text icon color="primary" v-on="on">
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </template>
                            Add
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </draggable>
                  </v-list>
                  <v-row>
                    <v-col cols="12">
                      <v-row justify="center">
                        <v-btn text color="primary" @click="onEdit(item)">
                          <v-icon left small>mdi-pencil</v-icon>Edit
                          {{ item.supplierName }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <get-more-results
              v-if="false"
              :first="first"
              @limitChange="onLimitChange"
              :items="availableServicesBySupplier"
              :totalItems="totalItems"
              :loading="$apollo.loading"
              :loadMoreEnabled="loadMoreEnabled"
              @loadMore="loadMore"
            ></get-more-results>
            <v-container>
              <v-pagination
                v-model="page"
                :length="pages"
                circle
                @input="onPaginationChange"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="debug">
      <code>load:{{ sortBy }}</code>
    </div>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { SUPPLIER_TYPES } from "../../../../../constants/supplierTypes";
import { SupplierTypeIconMixin } from "../../../../../mixins/SupplierTypeIconMixin";
import DestinationListSelect from "../../../shared/DestinationListSelect";
import { removeGQLTypename } from "../../../../../helpers";
import EventBus from "../../../../../store/event-bus";
import ItemPricesGrid from "../ItineraryBuilderItemQuickAddItemPricesGrid";
import GetMoreResults from "../../../shared/GetMoreResults";
import draggable from "vuedraggable";
import ServiceTypeMultiSelect from "../../../shared/ServiceTypeMultiSelect.vue";
import StarsListSelect from "../../../shared/StarsListSelect.vue";
const randomize = require("randomatic");
const AVAILABLE_SUPPLIERS_QUERY = gql`
  query availableSuppliers(
    $search: AvailableServicesSearchInput!
    $first: Int
    $filter: AvailableServiceFilterType
    $after: String
    $includeUnpriced: Boolean
    $skipDetails: Boolean
    $page: Int!
    $pageSize: Int!
    $orderBy: SortOrderType
  ) {
    availableServicesBySupplier(
      first: $first
      after: $after
      searchParams: $search
      filter: $filter
      includeUnpriced: $includeUnpriced
      skipDetails: $skipDetails
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          supplierName
          headOfficeName
          supplierCode
          boardBasis
          priceFrom
          priceFromCurrencyCode
          imageURL
          description
          serviceType
          availableServices {
            id
            serviceName
            serviceId
            supplierName
            supplierId
            priceFrom
            priceFromCurrencyCode
            rateTypeCode
            service {
              stdOccupancy
              code
              imageURL
              description
            }
            prices {
              id
              date
              currency
              ratePlan
              rateCode
              rateTypeName
              adultPrice
              childPrice
              infantPrice
              itemPrice
              isClosed
              isOnRequest
              remaining
            }
          }
        }
      }
    }
  }
`;
export default {
  name: "sfr-list",

  mixins: [SupplierTypeIconMixin],

  components: {
    DestinationListSelect,
    ItemPricesGrid,
    GetMoreResults,
    draggable,
    ServiceTypeMultiSelect,
    StarsListSelect,
  },

  props: {
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
    destinationId: {
      type: String,
      default: () => "",
    },
    agentId: {
      type: String,
      default: () => "",
    },
    department: {
      type: String,
      default: () => "",
    },
    adults: {
      type: String,
      default: () => "2",
    },
    children: {
      type: String,
      default: () => "0",
    },
    infants: {
      type: String,
      default: () => "0",
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    dragAndDrop: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      panel: null,
      searchPanel: 0,
      menu: false,
      supplier: "",
      service: "",
      first: 10,
      pageSize: 10,
      after: null,
      loadMoreEnabled: true,
      selectedSupplierType: this.supplierType
        ? this.supplierType
        : "ACCOMMODATION",
      selectedSupplierTypes: ["ACCOMMODATION"],
      multiSupplierTypes: this.$store.getters.localSettings("multiSFR", false),
      supplierTypes: SUPPLIER_TYPES,
      serviceTypes: [],
      selectedDestinationId: this.destinationId ? this.destinationId : "",
      supplier: "",
      service: "",
      searchParams: null,
      includeUnpriced: this.$store.getters.localSettings(
        "sfrIncludeUnpriced",
        false
      ),
      skipDetails: false,
      page: 1,
      pageSize: 10,
      load: false,
      ratingFilter: [],
      priceFromMin: null,
      priceFromMax: null,
      filter: null,
      sortBy: "suppliers.name asc",
      sortByOptions: [
        { text: "Supplier Name Asc", value: "suppliers.name asc" },
        { text: "Supplier Name Desc", value: "suppliers.name desc" },
        { text: "Price Asc", value: "prices.adult_sell_1 asc" },
        { text: "Price Desc", value: "prices.adult_sell_1 desc" },
      ],
    };
  },

  computed: {
    priceRangeSlider: {
      get() {
        return [this.priceFromMin || 0, this.priceFromMax || 10000];
      },
      set([min, max]) {
        this.priceFromMin = min > 0 ? min : null;
        this.priceFromMax = max < 10000 ? max : null;
      },
    },
    orderBy() {
      const [fieldName, direction] = this.sortBy.split(" ");
      return {
        fieldName,
        direction: direction.toUpperCase(),
      };
    },
    serviceTypesNamesFilter() {
      return this.selectedSupplierTypes.map((t) =>
        t == "ACCOMMODATION" ? "HOTELS" : t
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      return this.availableServicesBySupplier &&
        this.availableServicesBySupplier.edges
        ? this.availableServicesBySupplier.edges.map(removeGQLTypename)
        : [];
    },
    totalItems() {
      return this.availableServicesBySupplier &&
        this.availableServicesBySupplier.edges
        ? this.availableServicesBySupplier.totalCount
        : 0;
    },
    pages() {
      return Math.ceil(Number(this.totalItems) / this.pageSize);
    },
  },

  watch: {
    destinationId(newDest) {
      this.selectedDestinationId = newDest;
    },
    supplierType(newVal) {
      this.selectedSupplierType = newVal;
    },
  },

  methods: {
    onSortChange() {
      if (this.sortBy.includes("prices")) {
        this.includeUnpriced = false;
      }
    },
    clone(supplier) {
      return (item) => {
        return {
          ...item,
          id: randomize("Aa0", 32),
          uid: randomize("Aa0", 32),
          boardBasis: supplier ? supplier.boardBasis : "",
          startDate: this.startDate,
          endDate: this.endDate,
          serviceType: supplier.serviceType,
          price: item.priceFrom,
          currencyCode: item.priceFromCurrencyCode,
          qty: "1",
          adults: this.adults,
          children: this.children,
          infants: this.infants,
        };
      };
    },
    onPaginationChange() {
      this.onSearch(this.page);
    },
    onMultiSFRChange() {
      this.$store.dispatch("updateLocalSettings", {
        multiSFR: this.multiSupplierTypes,
      });
    },
    onIncludeUnpricedChange() {
      this.$store.dispatch("updateLocalSettings", {
        sfrIncludeUnpriced: this.includeUnpriced,
      });
    },
    onSupplierTypeClick(sType) {
      if (this.selectedSupplierTypes.indexOf(sType) > -1) {
        this.selectedSupplierTypes = [
          ...this.selectedSupplierTypes.filter((t) => t != sType),
        ];
      } else {
        this.selectedSupplierTypes.push(sType);
      }
    },
    loadMore() {
      this.$apollo.queries.availableServicesBySupplier.fetchMore({
        variables: {
          after: this.availableServicesBySupplier.pageInfo.endCursor,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEntries = fetchMoreResult.availableServicesBySupplier.edges;
          // console.log(
          //   fetchMoreResult,
          //   fetchMoreResult.availableServicesBySupplier
          // );
          this.loadMoreEnabled =
            fetchMoreResult.availableServicesBySupplier.pageInfo.hasNextPage;

          this.first = this.first + this.pageSize;

          return {
            availableServicesBySupplier: {
              __typename: previousResult.availableServicesBySupplier.__typename,
              totalCount:
                fetchMoreResult.availableServicesBySupplier.totalCount,
              pageInfo: {
                __typename:
                  previousResult.availableServicesBySupplier.pageInfo
                    .__typename,
                endCursor:
                  fetchMoreResult.availableServicesBySupplier.pageInfo
                    .endCursor,
                hasNextPage:
                  fetchMoreResult.availableServicesBySupplier.pageInfo
                    .hasNextPage,
              },
              edges: [
                ...previousResult.availableServicesBySupplier.edges,
                ...newEntries,
              ],
            },
          };
        },
      });
    },
    onEdit(item) {
      this.$emit("supplier-edit", { ...item, supplierId: item.id });
    },
    onItemClick(item, supplierRecord) {
      const selectedItem = {
        ...item,
        boardBasis: supplierRecord ? supplierRecord.boardBasis : "",
        startDate: this.startDate,
        endDate: this.endDate,
        serviceType: supplierRecord.serviceType,
        price: item.priceFrom,
        currencyCode: item.priceFromCurrencyCode,
        qty: "1",
        adults: this.adults,
        children: this.children,
        infants: this.infants,
      };
      //console.log("selectedItem", selectedItem);
      EventBus.$emit("showIitneraryItemEditor", selectedItem);
      const payload = { item: selectedItem, params: { ...this.searchParams } };
      this.$emit("item-selected", payload);
    },
    onServiceTypeChange() {
      this.service = "";
      this.supplier = "";
      this.loadMoreEnabled = true;
      this.page = 1;
      this.selectedSupplierTypes = [this.selectedSupplierType];
    },
    onSearch(page = 1) {
      this.searchPanel = null;
      page = isNaN(page) ? 1 : page;
      this.first = 10;
      this.loadMoreEnabled = true;
      this.panel = null;
      this.page = page;
      this.searchParams = {
        destinationId: this.selectedDestinationId,
        agentId: this.agentId,
        serviceType: this.selectedSupplierType,
        serviceTypes: this.multiSupplierTypes
          ? [...this.selectedSupplierTypes]
          : undefined,
        startDate: this.startDate,
        endDate: this.endDate,
        adults: this.adults.toString(),
        children: this.children.toString(),
        infants: this.infants.toString(),
        department: this.department,
        serviceTypeNames: [...this.serviceTypes],
        ratings: [...this.ratingFilter],
      };
      this.filter = {
        serviceNameContains: this.service,
        supplierNameContains: this.supplier,
        priceFrom_ge: this.priceFromMin || undefined,
        priceFrom_le: this.priceFromMax || undefined,
      };

      this.load = true;
    },
  },

  apollo: {
    availableServicesBySupplier: {
      query: AVAILABLE_SUPPLIERS_QUERY,
      variables() {
        return {
          first: 10,
          search: { ...this.searchParams },
          filter: { ...this.filter },
          includeUnpriced: this.includeUnpriced,
          page: this.page,
          pageSize: this.pageSize,
          orderBy: this.orderBy,
        };
      },
      skip() {
        return !this.searchParams || !this.load;
      },
      result() {
        this.load = false;
      },
      fetchPolicy: "network-only",
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style scoped>
.max-lines {
  display: block; /* or inline-block */
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 7.2em;
  line-height: 1.8em;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/sfr/SFRList.vue